import type React from "react"
import "./server-error-popup.css"
import { GetImages } from "../../utils/GetImages"

interface ServerErrorPopupProps {
  isOpen?: boolean
  onClose?: () => void
  supportEmail?: string
}

const ServerErrorPopup: React.FC<ServerErrorPopupProps> = ({
  isOpen,
  onClose,
  supportEmail = "support@propertelligent.com",
}) => {
  if (!isOpen) return null

  
  return (
    <div id="error500" className="error-overlay">
      <div className="error-popup">
        <button className="close-button" onClick={onClose}>
        <img src={GetImages.crossIcon} alt="Close" width={16} height={16} />
        </button>

        <div className="error-icon">
        <img src={GetImages.serverErrorIcon} alt="Close" width={40} height={40} />
        </div>

        <h2 className="error-title">Something Went Wrong</h2>

        <p className="error-message">
          We're currently experiencing an issue. Our team is actively investigating and working on a fix. We apologise
          for the inconvenience and appreciate your patience.
        </p>

        <p className="error-support">
          If the issue continues to persist, please contact our support at{" "}
          <a href={`mailto:${supportEmail}`} className="support-link">
            {supportEmail}
          </a>
        </p>
      </div>
    </div>
  )
}

export default ServerErrorPopup
